import React, { Fragment } from "react";
import InnerBannerSection from "../../utility/ui-components/innerPageBanner";
import PrivacySection from "../home/privacySection"
import { useLocation } from "react-router-dom";
import privacyData from "../../../common/assets/data/privacy";
function PolicySection() {
  const location = useLocation();
  window.scrollTo(0 , 0);
  const content = privacyData.filter((list) => {
    return list.path === location.pathname;
  });
  let data = content[0]?.pageContent;
  console.log(location.pathname)
  return (
    <Fragment>
      <InnerBannerSection content={data.PageBanner} />
      <PrivacySection content={data.sectionData} />
    </Fragment>
  );
}

export default PolicySection;
